<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="blue">
                            <v-toolbar-title class="my-0 py-0">Adjuntar Archivo de Nota N° {{ codgral
                                }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-toolbar>
                    </v-card>
                    <v-card color="blue lighten-4">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="6" sm="4" md="2">
                                    <h6 color="black"><b>Fecha: {{ fecha }} </b></h6>
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    <h6 color="black"><b>Responsable: {{ responsable }} </b></h6>
                                </v-col>
                                <v-col cols="6" sm="4" md="2">
                                    <h6 color="black"><b>Factibilidad: {{ fact }} </b></h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="6">
                                    <h6 color="black"><b>Empresa: {{ empresa }} </b></h6>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <h6 color="black"><b>Referencia: {{ referencia }} </b></h6>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card v-if="fileInfos.length > 0" class="mx-auto">
                        <v-list>
                            <v-subheader>Lista de archivos</v-subheader>
                            <v-list-item-group color="primary">
                                <v-list-item v-for="(file, index) in fileInfos" :key="index">
                                    <v-list-item-content>
                                        <v-list-item-title class="mb-3">
                                            <v-icon color="red"
                                                @click="borrarArchivo(file.descripcion, index)">mdi-close</v-icon>
                                            <a target="_blank" :href="'https://api.icssa.com.ar/notas/' + file.descripcion
        ">{{ file.titulo }}</a>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                    <v-card>
                        <v-card-text>
                            <div>
                                <v-row dense>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-file-input multiple show-size label="Seleccionar Archivo" v-model="fotos"
                                            @change="selectFiles"></v-file-input>
                                    </v-col>
                                    <v-col cols="12" sm="2" md="2">
                                        <v-btn color="success" small @click="uploadFiles">
                                            Subir Archivo
                                            <v-icon right dark>mdi-cloud-upload</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card-text>
                    </v-card>

                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
export default {
    data: (vm) => ({
        usuario: "",
        valid: false,
        validsubir: false,
        deshabilitar: false,
        lazy: false,
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        empresa: "",
        responsable: "",
        referencia: "",
        fecha: "",
        fact: "",
        periodo: "",
        mensaje: "",
        fotos: [],
        archivo: [],
        selectedFiles: undefined,
        progressInfos: [],
        message: "",
        fileInfos: [],
    }),
    props: ["visible", "codgral"],
    computed: {
        show: {
            get() {
                //this.mostrar = true;
                if (this.visible == true) {
                    this.cargarnota();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        vaciarModels() {
            this.empresa = "";
            this.resp = "";
            this.referencia = "";
            this.fecha = "";
            this.fact = "";
        },
        cargarnota() {
            let self = this;
            const codgral = this.codgral.substring(0, 4);
            axios
                .get("/Comercial/CargarNota?", {
                    params: {
                        codgral: codgral,
                    },
                })
                .then((response) => {
                    console.log(response.data);
                    self.responsable = response.data.responsable;
                    self.empresa = response.data.empresa;
                    self.referencia = response.data.referencia;
                    self.fecha = response.data.fecha;
                    self.periodo = response.data.periodo;
                    self.fact = response.data.fact;
                    self.fileInfos = response.data.informes;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        selectFiles(files) {
            this.progressInfos = [];
            this.selectedFiles = files;
        },

        uploadFiles() {
            this.message = "";
            for (let i = 0; i < this.selectedFiles.length; i++) {
                this.upload(i, this.selectedFiles[i]);
            }
        },

        upload(idx, file) {
            const codigo = this.codgral;
            let self = this;
            let formData = new FormData();

            console.log("archivo: " + file.name + "codigo" + codigo);
            formData.append("path", file, file.name);
            formData.append("titulo", self.codgral);
            formData.append("descripcion", "");
            formData.append("tipo", "EI044");
            // if (this.editar == true) {
            //   formData.append("codgral", self.codgral)
            // }
            // else {
            formData.append("codgral", self.codgral)
            // }
            axios
                .post("Comercial/GuardarAdjuntoNota", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    self.fileInfos.push({
                        url: response.data.path,
                        titulo: response.data.titulo,
                        descripcion: response.data.descripcion,
                    });
                    self.fotos = [];
                    self.titulo = "";
                    console.log(response.data.descripcion);
                })
                .catch((error) => {
                    console.log("ERROR:  " + error);
                    self.showAlert({
                        icon: "error",
                        title: "El archivo no se pudo subir",
                        vm: self,
                    });
                });

        },
        borrarArchivo(file, index) {
            let self = this;
            console.log("archivo a borrar:" + file);
            axios
                .get("/Comercial/BorrarArchivo?", {
                    params: {
                        ruta: file,
                    },
                })
                .then((response) => {
                    self.showAlert({
                        icon: "success",
                        title: "Archivo borrado",
                        vm: this,
                    });
                    self.fileInfos.splice(index, 1);
                })
                .catch((error) => {
                    console.log(error);
                });
        },


        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 5000,
            });
        },
    },
};
</script>
